import { Box, Container, Typography } from "@mui/material";
import { AnimatePresence, motion, useScroll, useTransform } from "framer-motion";
import AudioPlayer from "../components/AudioPlayer";
import { useMemo, useRef, useState } from "react";
import Gallery from "../components/Gallery";
import photoData from "../assets/photoData.json";
import { ScrollButton } from "../components/ScrollButton";


export const LandingSection = ({ onPlay, startBgColor = "#ffffff", endBgColor = "#FFE6F9" }) => {
  const sectionRef = useRef(null);
  const [isPlayed, setIsPlayed] = useState(false);

  // Track scroll progress relative to this section
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start end", "end start"], // Start when section enters, end when it leaves
  });

  // useEffect(() => {
  //   scrollYProgress.onChange((latest) => {
  //     console.log("Scroll progress:", latest);
  //   });
  // }, []);

  // Interpolate background color from white to pink
  const transitionBgColor = useTransform(scrollYProgress, [0.2, 0.76], [startBgColor, endBgColor]);
  const backgroundColor = useMemo(() => {
    return isPlayed ? transitionBgColor : startBgColor;
  }, [isPlayed]);

  // Scroll down 100vh / 2
  const handleScrollDown = () => {
    const currentScroll = window.scrollY;
    const viewPortHeight = window.innerHeight;
    window.scrollTo({
      top: currentScroll + (viewPortHeight / 2),
      behavior: "smooth",
    });
  }

  // Photo data
  const images = photoData
    .filter((photo) => !photo.isVideo)
    // .slice(0, 30)
    .map((photo) => ({
      id: photo.src,
      src: `/web-images/${photo.src}`,
    }));

  // Music data
  const musicData = [
    { src: "/music/รักนานๆ.mp3", label: "รักนานๆ" },
    { src: "/music/ดาวหางฮัลเลย์.mp3", label: "ดาวหางฮัลเลย์" },
    { src: "/music/คู่ชีวิต-COCKTAIL.mp3", label: "คู่ชีวิต" },
  ];

  const [currentMusic, setCurrentMusic] = useState(-1);

  // Handle Player
  const handlePlay = () => {
    onPlay && onPlay();
    setIsPlayed(true);
  }

  return (
    <motion.div
      style={{ background: backgroundColor }}
      ref={sectionRef}
    >
      <Box sx={{ p: 4, display: "flex", flexDirection: "column", alignItems: "center", position: "relative", minHeight: "100dvh" }}>
        <Typography
          align="center"
          variant="h4"
          color="secondary"
          sx={{ fontWeight: "bold", mb: 2 }}
        >
          สุขสันต์วันวาเลนไทน์ :) 🌹
        </Typography>
        <Typography variant="h6" sx={{ mt: 2, mb: 4 }} align="center">
          ของขวัญพิเศษจากเค้าส่งถึงบี๋ <br />Handmade with love 💖
        </Typography>

        {/* Audio player */}
        <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          {(musicData.map((music, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 1, marginBottom: 16 }}
              animate={{
                opacity: (index === currentMusic || currentMusic === -1) ? 1 : 0,
                height: (index === currentMusic || currentMusic === -1) ? "auto" : 0,
                marginBottom: (index === currentMusic || currentMusic === -1) ? 16 : 0,
              }}
              exit={{ opacity: 0 }}
              style={{ zIndex: index + 1 }}
            >
              <AudioPlayer
                audioSrc={music.src}
                onPlay={() => {
                  setCurrentMusic(index);
                  handlePlay();
                }}
                onPause={() => setCurrentMusic(-1)}
                label={music.label}
              />
            </motion.div>
          )))}

          <Typography variant="caption" sx={{ mb: 4 }}>
            ก่อนอื่น มาเลือกเพลงกันน
          </Typography>
        </Box>

        {/* Scroll down text */}
        {isPlayed && (
          <ScrollButton onClick={() => handleScrollDown()} text="เลื่อนลงมาเลยยย !!" />
        )}
      </Box>

      {/* Fade in and out */}
      {isPlayed && (
        <Container maxWidth="lg" sx={{ padding: "0 !important" }}>
          <Gallery numCols={5} images={images} />
        </Container>
      )}
    </motion.div >
  );
};
